import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { WhitelistAPI } from "../../api/api";
import "./Whitelist.css";

export default function WhitelistList() {
  const [ips, setIps] = useState([]);
  const navigate = useNavigate();

  const loadIPs = async () => {
    try {
      const res = await WhitelistAPI.getAll();
      setIps(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Failed to load whitelist IPs:", err);
    }
  };

  useEffect(() => {
    loadIPs();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this IP?")) return;
    try {
      await WhitelistAPI.delete(id);
      loadIPs();
    } catch (err) {
      console.error("Failed to delete IP:", err);
    }
  };

  return (
    <div className="whitelist-main">
      <h1>Whitelist IP`s</h1>
      <div className="create-btn">
        <button
          onClick={() => navigate("/whitelist/create")}
          className="px-3 py-1 bg-green-500 text-white rounded mb-4"
        >
          Add New IP
        </button>
      </div>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Id</th>
              <th>Ip Address</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {ips.map((ip) => (
              <tr key={ip.id}>
                <td>{ip.id}</td>
                <td className="t-address">{ip.ipAddress}</td>
                <td className="t-btn">
                  <button
                    onClick={() => navigate(`/whitelist/edit/${ip.id}`)}
                    className="edit-btn"
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                  <button
                    onClick={() => handleDelete(ip.id)}
                    className="del-btn"
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
